/**
 * Wizard constants for attack path modals.
 *
 * These constants ensure consistent height between loading skeletons and content
 * to prevent layout shifts during loading->content transitions.
 */

/**
 * Height constants for wizard step content areas.
 * Derived from SelectionTable: maxRows (6) * ROW_HEIGHT (44px) + TABLE_HEADER_HEIGHT (32px) = 296px
 *
 * The header height must be included because it's inside the scroll container.
 * This value matches the "Add custom" fallback sections and SelectionTable
 * component heights, ensuring no height jump during loading transitions.
 */
export const STEP_CONTENT_HEIGHT = 296;
export const STEP_CONTENT_HEIGHT_CLASS = 'min-h-[296px]' as const;

/**
 * Scroll indicator height: py-2 (16px padding) + content (~20px) = 36px
 */
export const SCROLL_INDICATOR_HEIGHT = 36;

/**
 * Total height when pagination is enabled (table + indicator space)
 */
export const STEP_CONTENT_WITH_PAGINATION_HEIGHT =
  STEP_CONTENT_HEIGHT + SCROLL_INDICATOR_HEIGHT; // 332px
export const STEP_CONTENT_WITH_PAGINATION_HEIGHT_CLASS =
  'min-h-[332px]' as const;

/**
 * Unified wizard step height for consistent modal sizing across all steps.
 * Set to 304px to match IconGrid (3 icon rows × 96px + 16px padding).
 * Using a single height prevents modal resizing between wizard steps.
 */
export const WIZARD_STEP_HEIGHT = 304;
export const WIZARD_STEP_HEIGHT_CLASS = 'min-h-[304px]' as const;

/**
 * Unified minimum height for all wizard step containers.
 * Ensures consistent modal height across all steps (search, icon, status, etc.).
 *
 * Derived from search steps: description + search input + table (6 rows) +
 * scroll indicator + CurrentlyEditingDisplay (edit mode) + gaps = 492px
 */
export const WIZARD_STEP_MIN_HEIGHT = 492;
export const WIZARD_STEP_MIN_HEIGHT_CLASS = 'min-h-[492px]' as const;
